import { render } from "./WholesaleFooter.vue?vue&type=template&id=5d9f5d24"
import script from "./WholesaleFooter.vue?vue&type=script&lang=js"
export * from "./WholesaleFooter.vue?vue&type=script&lang=js"

import "./WholesaleFooter.vue?vue&type=style&index=0&id=5d9f5d24&lang=css"
script.render = render

export default script